// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FlagSection_wrap__2rUzd","textSpacer":"FlagSection_textSpacer__-qDJ9","FlagSec":"FlagSection_FlagSec__2Z99K","FlagSec_content":"FlagSection_FlagSec_content__2e8C3"};